import { Controller } from "@hotwired/stimulus";
import React from "react";
import { createRoot } from "react-dom/client";

import { Viewer } from "src/admin/catalog/viewer";

export default class extends Controller<HTMLDivElement> {
  static values = {
    catalogUrl: String,
    outOfStockListUrl: String,
    editorUrl: String,
    storeId: String,
    updateStockUrl: String,
    manualStockManagement: Boolean
  }

  declare catalogUrlValue?: string;
  declare outOfStockListUrlValue?: string;
  declare editorUrlValue?: string;
  declare storeIdValue: string;
  declare updateStockUrlValue: string;
  declare manualStockManagementValue: boolean;

  connect() {
    const root = createRoot(this.element);

    root.render(React.createElement(Viewer, {
      catalogUrl: this.catalogUrlValue,
      outOfStockListUrl: this.outOfStockListUrlValue,
      editorUrl: this.editorUrlValue,
      storeId: this.storeIdValue,
      updateStockUrl: this.updateStockUrlValue,
      manualStockManagement: this.manualStockManagementValue,
    }));
  }
}
